import React from 'react';
import {BadgeTranslations, PersonalisedBadge} from '../types';
import {Badge, BadgeProps} from './Badge';

export const PersonalizedBadge: React.FC<
  BadgeProps & {
    type: PersonalisedBadge;
    translations: BadgeTranslations;
  }
> = ({type, translations, ...badgeProps}) => {
  const badge = {
    favorite: {
      text: translations.personalized.favorite,
      emoji: '❤️',
    },
    oftenBought: {
      text: translations.personalized.oftenBought,
      emoji: '🔥',
    },
    recommended: {
      text: translations.personalized.recommended,
      emoji: '👌',
    },
  }[type];

  return (
    <Badge {...badgeProps} name={type} text={badge.text} emoji={badge.emoji} />
  );
};
